export const ECOM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd'
export const ECOM_MODULE_NAME = 'wix-ecom-frontend'
export const ECOM_BI_ENDPOINT = 'ecom-platform-data'

export enum WixEcomSdkInteraction {
	REFRESH_CART = 'refresh-cart',
	ON_CART_CHANGE = 'on-cart-change',
	OPEN_SIDE_CART = 'open-side-cart',
	NAVIGATE_TO_CART_PAGE = 'navigate-to-cart-page',
	NAVIGATE_TO_CHECKOUT_PAGE = 'navigate-to-checkout-page',
	GET_CUSTOMER_SELECTED_CURRENCY = 'get-customer-selected-currency',
}
